import { IFormStructureSection } from "../../../model/report/applicantdata/FormStructureSection";
import { IReport7Applicant } from "../../../model/report/report7/Report7Applicant";
import { IReport7NumericalValue } from "../../../model/report/report7/Report7NumericalValues";

export interface TReport7NumericValuePresentationModel {
  formStructureSectionName: string;
  amount: number;
  numberOfNumericValues: number;
  applicantId?: number;
}

export interface IReport7NumericValuePresentationModel
  extends TReport7NumericValuePresentationModel {}

const Report7NumericValuePresentationModel = (
  data: TReport7NumericValuePresentationModel
): IReport7NumericValuePresentationModel => {
  return {
    ...data
  };
};

const getAmountsSum = (
  numericValues: IReport7NumericalValue[] = []
): number => {
  const amountsList = numericValues.map((a) => a.valueN);
  return amountsList.reduce((prev: number, currnet: number) => {
    return prev + currnet;
  }, 0);
};

const getNumberOfValues = (numericValues: IReport7NumericalValue[]) => {
  const nonEmptyAmounts = numericValues.filter(
    (amount) => amount.valueN && amount.valueN !== 0
  );
  const numberOfNonEmptyValues = nonEmptyAmounts.length;
  return numberOfNonEmptyValues;
};

const Report7NumericValuePresentationModelList = (
  numericValues: IReport7NumericalValue[],
  selectedFormStructureSections: IFormStructureSection[],
  applicants: IReport7Applicant[]
): IReport7NumericValuePresentationModel[] => {
  let numericValuesPresentationModelList: IReport7NumericValuePresentationModel[] = [];

  applicants.forEach((applicant: IReport7Applicant) => {
    selectedFormStructureSections.forEach(
      (selectedStructureSection: IFormStructureSection) => {
        const matchingNumericValues = numericValues.filter(
          (numericValue: IReport7NumericalValue) =>
            numericValue.sectionName === selectedStructureSection.sectionName &&
            numericValue.qualifierCode ===
              selectedStructureSection.qualifierCode &&
            numericValue.attributeCode ===
              selectedStructureSection.attributeCode &&
            numericValue.applicantId === applicant.id
        );
        if (matchingNumericValues.length > 0) {
          numericValuesPresentationModelList.push(
            Report7NumericValuePresentationModel({
              formStructureSectionName: selectedStructureSection.fullName,
              numberOfNumericValues: getNumberOfValues(matchingNumericValues),
              amount: getAmountsSum(matchingNumericValues),
              applicantId: applicant.id
            })
          );
        } else {
          numericValuesPresentationModelList.push(
            Report7NumericValuePresentationModel({
              formStructureSectionName: selectedStructureSection.fullName,
              numberOfNumericValues: 0,
              amount: 0,
              applicantId: applicant.id
            })
          );
        }
      }
    );
  });
  return numericValuesPresentationModelList;
};

export default Report7NumericValuePresentationModelList;
